import { RNG } from "rot-js";
import { DMap } from "../../../lib/dMap/dMap";
import { getRampValue } from "../../actors/Ramp";
import EntityManager from "../../EntityManager";
import { getItemsForPosition } from "../../GameManager";
import { ItemTypes } from "../../items/itemsTypes";
import { BasicMap } from "../BasicMap";
import { getRandomInBounds } from "./placement";

const MIN_ITEMS = 3;
const MAX_ITEMS = 4;

const depthBudget = [10, 20, 20, 20, 20];
type ItemPool = Partial<{ [key in keyof typeof ItemTypes]: number }>;

const itemTiers: Record<number, ItemPool> = {
  1: {
    healingPotion: 2,
    rejuvPotion: 0,
    staminaPotion: 2,
    scrollFreedom: 1,
    potionLettersMinor: 2,
    potionLettersMajor: 0,
    potionSpells: 0,
    scrollPoly: 1,
    scrollMorph: 0,
    scrollWeaken: 1,
    scrollHinder: 0,
  },
  4: {
    healingPotion: 1,
    rejuvPotion: 1,
    staminaPotion: 2,
    scrollFreedom: 1,
    potionLettersMinor: 2,
    potionLettersMajor: 1,
    potionSpells: 2,
    scrollPoly: 1,
    scrollMorph: 1,
    scrollWeaken: 1,
    scrollHinder: 1,
  },
  7: {
    healingPotion: 0,
    rejuvPotion: 0,
    staminaPotion: 0,
    scrollFreedom: 1,
    potionLettersMinor: 0,
    potionLettersMajor: 0,
    potionSpells: 1,
    scrollPoly: 2,
    scrollMorph: 1,
    scrollWeaken: 2,
    scrollHinder: 1,
  },
};

export const placeItems = (rng: typeof RNG, map: BasicMap, dMap: DMap) => {
  const itemTable = getRampValue(itemTiers, map.depth);

  if (!itemTable) {
    console.error("did not receive itemTable!");
    return;
  }

  const total = rng.getUniformInt(MIN_ITEMS, MAX_ITEMS);

  for (let i = 0; i < total; i++) {
    const toSpawn = rng.getWeightedValue(itemTable) as keyof typeof ItemTypes;
    if (toSpawn) {
      for (let fail = 0; fail < 200; fail++) {
        const pos = getRandomInBounds(rng, {
          x: 0,
          y: 0,
          h: map.height,
          w: map.width,
        });
        const dist = dMap.get(pos);
        if (dist && !getItemsForPosition(pos.x, pos.y).length) {
          EntityManager.createItem(ItemTypes[toSpawn], pos.x, pos.y);
          break;
        }
      }
    } else {
      console.error("returned no toSpawn");
    }
  }
};
